import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import Link from './Link.js';
import Icon from '../Icon/Icon.js';
import { jsx } from 'react/jsx-runtime';
import { ICON_UI_CHEVRON_RIGHT } from '../../icons/ICON_UI_CHEVRON_RIGHT.js';

var _excluded = ["children", "ariaLabel"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var ArrowLink = function ArrowLink(_ref) {
  var _ref$children = _ref.children,
    children = _ref$children === void 0 ? null : _ref$children,
    ariaLabel = _ref.ariaLabel,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/jsx(Link, _objectSpread(_objectSpread({}, rest), {}, {
    iconAfter: /*#__PURE__*/jsx(Icon, {
      path: ICON_UI_CHEVRON_RIGHT
    }),
    ariaLabel: ariaLabel,
    children: children
  }));
};
var ArrowLink$1 = ArrowLink;

export { ArrowLink$1 as default };
//# sourceMappingURL=ArrowLink.js.map
